// When a Sumo region is not specified using the template parameter, default to
// the region "us2". When the Sumo region is excluded from the URL (i.e.
// "service.sumologic.com"), then it is expected the region will default to
// "us1" by the server.
const SUMO_REGION_US1 = 'us1';
export const SUMO_REGION_US2 = 'us2';

const warnings = {
  conflictingRegion: `This URL appears to route to Sumo Logic using the default deployment, "${SUMO_REGION_US1}". However, this does not match the currently configured Sumo Logic deployment. If needed, contact Sumo Logic Cloud SIEM support to modify the Sumo Logic deployment.`,
  defaultRegion: `This URL appears to route to Sumo Logic, but a Sumo Logic deployment is not configured. If needed, contact Sumo Logic Cloud SIEM support to complete the setup.`,
  missingRegion: `The URL contains the template variable {{sumoregion}}, but a Sumo Logic deployment is not configured. Contact Sumo Logic Cloud SIEM support to complete the setup. This URL will default to the deployment "${SUMO_REGION_US2}".`,
};

export const getSumoUrlWarning = (url: string, region?: string) => {
  let warning: string | undefined;

  if (!region && url.includes('{{sumoregion}}')) {
    warning = warnings.missingRegion;
  }

  // Handle default Sumo region
  else if (
    url.includes('service.sumologic.com') &&
    region &&
    region?.toLowerCase() !== SUMO_REGION_US1
  ) {
    // The default region will be used, but it conflicts with the
    // configured region.
    warning = warnings.conflictingRegion;
  }

  return warning;
};
